var render, staticRenderFns
import script from "./mixin-prevent-leave.vue?vue&type=script&lang=js&"
export * from "./mixin-prevent-leave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mixin-prevent-leave.vue"
export default component.exports